var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex fd-column ITEM p-b-2"},[_c('div',{staticClass:"d-flex fd-row"},[_c('img',{staticClass:"IMAGE m-b-1",attrs:{"src":_vm.item.image}}),_c('div',{staticClass:"h5 text-bold p-l-2 m-t-1"},[_vm._v(_vm._s(_vm.item.title))])]),_c('p',[_vm._v(_vm._s(_vm.item.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }